module.exports = __webpack_public_path__ + "static/media/male.5b2b53b9.png";